module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And God said, “Let there be dog,” and there ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("was dog. \n\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("God saw that dog was good, and said, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Who’s a good dog?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And it was dog. Yes it was.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_dog.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why should we care about beauty, anyway?”")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("she asked the dark. \n\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Because creation is temporary,” it replied,")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“and destruction is forever.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer040"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "Text l3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ownership is an illusion, the cat knew. Nothing is forever.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_edge.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text2 l3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" They needed to learn.    ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text l3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" He began pushing another glass toward the table’s edge.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_edge1.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why is the world so cruel?” she asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To remind us to be kind,” said the Oracle. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Really?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No. But it’s a good enough reason to try.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He sat, alone. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("No one had come to his Halloween party. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That or all his guests had dressed as ghosts")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and their costumes were amazing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’m dead? It’s over?” he asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes. What did you think?” asked Death. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Of life?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I’ve always wanted to try it.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In faded sheets with fraying ends, he thought of love and sun and friends. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("His share of days and where they went. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("All gone now. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But so well spent.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He pulled the sheet over his head, thinking it")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("would make him a ghost. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("When he tripped on the hem at the top of the")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("stairs, it did.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_sheet.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I suppose this is goodbye.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Maybe, but we’ll always have Rome.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“We never went to Rome.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I know. Regrets last longer than memories.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Desperate to salve the pain, she stole his heart for her own. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But for all her love, it wouldn’t beat for her. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Or at all.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“How can I feel strong?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This hate potion would do,” the witch said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh. How can I BE strong?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Don’t take the hate potion.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_littledeath.png"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('p', {
    staticClass: "Text2 l1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The small hooded figure perched on her vanity. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text l1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Death? Damn. I’ll miss my date,” she said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text l1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No, I’m Little Death. The date will go fine.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I just want someone to love me forever,” ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("he said. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I will,” she promised, “forever and always.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh,” he said, “I mean someone else.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("When they came from the stars, it was to take our hearts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("But it was too late. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("One look at us told them that we hadn’t any left.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Are we alone in the universe?” she asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes,” said the Oracle. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“So there’s no other life out there?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“There is. They’re alone too.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer056"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("They watched as the meteor lit the sky. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Is this the end?” one asked. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Only of us,” said the other. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then what?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Something better.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/asf_end.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer058"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Are you here to conquer Earth?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The aliens exchanged a look. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No,” one said, “this is more like an"), _c('br'), _vm._v(" intervention. You guys need to relax.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Her life story was being written in a different")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("genre than she’d thought. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She’d expected drama. Maybe romance. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Dystopian was a surprise.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Don’t worry; we’re here,” said the story police. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Why?” asked the writer. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To present our opinions as fact.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No thank you.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh, we insist.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer061"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“This magic pen sucks,” he said. “It only writes garbage!”")]), _c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The pen isn’t magic,” said the wizard. “The")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("garbage was inside you all along.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a2bdd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/A_Small_Fiction_ebook1.vue
// module id = 63
// module chunks = 0